import { MasksSummary as MasksSummaryType } from "@/api/episodes-types";
import { colors, Stack } from "@mui/material";
import { SummaryBox } from "../ui/SummaryBox";

type Props = {
  summary: MasksSummaryType;
};

export function MasksSummary({ summary }: Props) {
  const { waiting, new: newImages, accepted, rejected, submitted } = summary;

  return (
    <Stack
      gap={0.5}
      direction={"row"}
      sx={{ verticalAlign: "middle", display: "inline-flex" }}
    >
      <SummaryBox
        tooltip="Waiting for initial generation or regeneration. Not yet available for validation."
        count={waiting}
      />
      <SummaryBox
        tooltip="New or regenerated masks. You can accept or reject them in validation flow."
        count={newImages}
        sx={[
          {
            color: colors.blue[800],
            backgroundColor: colors.blue[50],
          },
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "background.paper",
              color: colors.blue[300],
            }),
        ]}
      />
      <SummaryBox
        tooltip="Accepted masks, ready to be submitted. You can still reject them."
        count={accepted}
        sx={[
          {
            color: colors.green[800],
            backgroundColor: colors.green[50],
          },
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "background.paper",
              color: colors.green[300],
            }),
        ]}
      />
      <SummaryBox
        tooltip="Rejected masks, ready to be submitted. You can still accept them."
        count={rejected}
        sx={[
          {
            color: colors.red[800],
            backgroundColor: colors.red[50],
          },
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "background.paper",
              color: colors.red[300],
            }),
        ]}
      />
      <SummaryBox
        tooltip="Accepted masks that are locked and cannot be rejected anymore."
        count={submitted}
        sx={[
          {
            color: colors.purple[800],
            backgroundColor: colors.purple[50],
          },
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "background.paper",
              color: colors.purple[300],
            }),
        ]}
      />
    </Stack>
  );
}
